import React from 'react';
import CardBase from './CardBase';
import PriceBubble from './PriceBubble';
import FlavorIcon from './FlavorIcon';

interface FlavoredDrinkCardProps {
    drinkName: string;
    type: 'still' | 'sparkling';
    tagline: string;
    price: string;
    productImageSrc: string;
    productImageClassName: string;
    flavorIconSrc: string;
    flavorIconTop?: string;
    flavorIconImageTop?: string;
    onClick: () => void;
    isSelected: boolean;
    selectedStyle: string;
    bubbles?: { src: string, className: string }[];
}

const FlavoredDrinkCard: React.FC<FlavoredDrinkCardProps> = ({
    drinkName,
    type,
    tagline,
    price,
    productImageSrc,
    productImageClassName,
    flavorIconSrc,
    flavorIconTop,
    flavorIconImageTop,
    onClick,
    isSelected,
    selectedStyle,
    bubbles
}) => {
    const isStill = type === 'still';
    // const title = isStill ? <>still<br />{drinkName}</> : <>sparkling {drinkName}</>;
    const title = isStill ? <>still {drinkName}</> : <>sparkling {drinkName}</>;
    const titleClassName = `h-20 ${isStill ? 'w-64 left-[30px]' : 'w-72 left-[25px]'} top-[203px] absolute text-center text-white text-3xl font-extrabold font-['Montserrat'] uppercase leading-none my-1`;
    // const taglineTop = drinkName === 'lemon' && isStill ? 'top-[265px]' : 'top-[279px]';
    const taglineTop = 'top-[279px]';
    const taglineClassName = `w-64 h-7 ${isStill ? 'left-[40px]' : 'left-[37px]'} ${taglineTop} absolute text-center text-white text-xl font-normal font-['Montserrat'] leading-tight`;

    return (
        <CardBase onClick={onClick} isSelected={isSelected} selectedStyle={selectedStyle}>
            <div className={titleClassName}>{title}</div>
            <div className={taglineClassName}>{tagline}</div>
            <PriceBubble price={price} isStill={isStill} />
            <img src={productImageSrc} className={productImageClassName} alt={drinkName} />
            <FlavorIcon iconSrc={flavorIconSrc} top={flavorIconTop} imageTop={flavorIconImageTop} />
            {bubbles && bubbles.map((bubble, index) => (
                <img key={index} className={bubble.className} src={bubble.src} alt="bubble" />
            ))}
        </CardBase>
    );
};

export default FlavoredDrinkCard;
